export const formatDate = (d) => {
    if(!d) return '';
    return new Date(d).toLocaleDateString("pt-BR");
}